import config from '@/config';
import axios from 'axios';
import qs from 'querystring';
// import rp from 'request-promise-native';

export function linkedinLogin() {
	const data = qs.stringify({
			'response_type' : 'code',
			'redirect_uri' : `${process.env.BASE_URL}/auth/linkedin/callback`,
			'client_id' : '78dyng07s6xrbc',
			'client_secret' : 'w104AJpWr4f99wQA',
			'state' : '987654321'
	});

	window.location = 'https://www.linkedin.com/oauth/v2/authorization?' + data;
}

export async function linkedinCallback(code, state){
		const lnResponse = await axios.post(config.services.companies + '/lntoken', {
			code: code,
			state: state
		});

		let info = {
			provider: 'cognito-identity.amazonaws.com',
			token: lnResponse.data.token,
			accessToken: lnResponse.data.access_token,
			expiration: lnResponse.data.expiration,
			identityId: lnResponse.data.identityId
		};
		const today = new Date();
		info.expiration = today.getTime() + 48*60*60*1000;

		return info;
}



// WEBPACK FOOTER //
// ./src/libs/providers/linkedin.js